// extracted by mini-css-extract-plugin
module.exports = {"list":"Items_list__V523s","nodata":"Items_nodata__2UrQ6","card":"Items_card__2AeQ2","loader":"Items_loader__2AcYF"};